module.exports = "data:application/vnd.ms-fontobject;base64,"